import { createBrowserRouter as createBrowserRouterReact } from 'react-router-dom';
import { createBrowserRouter as createBrowserRouterRUM } from '@datadog/browser-rum-react/react-router-v6';
import { reactPlugin } from '@datadog/browser-rum-react';

import type { IDatadog } from './types';

import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';

class DatadogRUM {
  private sessionSampleRate: number;
  private replaySampleRate: number;
  private replayDefaultMasking: DefaultPrivacyLevel;
  private supportReactRouter: boolean;

  private isInited: boolean;

  constructor() {
    this.sessionSampleRate = 20;
    this.replaySampleRate = 0;
    this.replayDefaultMasking = DefaultPrivacyLevel.MASK;
    this.supportReactRouter = true;

    this.isInited = false;
  }

  init({ sessionSampleRate, replaySampleRate, replayDefaultMasking, supportReactRouter }: IDatadog = {}) {
    if (this.isInited) return;

    this.sessionSampleRate = sessionSampleRate ?? this.sessionSampleRate;
    this.replaySampleRate = replaySampleRate ?? this.replaySampleRate;
    this.replayDefaultMasking = replayDefaultMasking ?? this.replayDefaultMasking;
    this.supportReactRouter = supportReactRouter ?? this.supportReactRouter;

    datadogRum.init({
      applicationId: import.meta.env.DD_RUM_APPLICATION_ID,
      clientToken: import.meta.env.DD_RUM_CLIENT_TOKEN,
      site: 'datadoghq.com', // DO NOT CHANGE
      service: import.meta.env.DD_SERVICE_NAME,
      env: import.meta.env.ENV,

      version: import.meta.env.RELEASE_DATE,
      sessionSampleRate: this.sessionSampleRate,
      sessionReplaySampleRate: this.replaySampleRate,
      defaultPrivacyLevel: this.replayDefaultMasking,
      plugins: this.supportReactRouter ? [reactPlugin({ router: true })] : [],
    });

    if (this.replaySampleRate > 0) {
      datadogRum.startSessionReplayRecording();
    }

    this.isInited = true;
  }

  getReactRouter() {
    if (!this.supportReactRouter) {
      return createBrowserRouterReact;
    } else {
      return createBrowserRouterRUM;
    }
  }
}

export default new DatadogRUM();
